module.exports = __webpack_public_path__ + "img/tu-logo.6e24aec5.svg";